import { BadgeAccountOutlineIcon } from './BadgeAccountOutlineIcon';

/**
 * author: Michael Richins
 * id 37856000-4337-42D9-B273-9C9656E9CFCD
 * name badge-account-outline
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/badge-account-outline.svg
 * tags
 * - Account / User 
 */
export const UserBadgeOutlineIcon = BadgeAccountOutlineIcon;
export default UserBadgeOutlineIcon